module.exports = __webpack_public_path__ + "static/img/039安监大数据平台.bd08bfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/039安监大数据平台.jpg
// module id = /Ubc
// module chunks = 0